<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="结算单编码">
					<el-input v-model="form.proofbillcode"></el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	//import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return {}
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				form: {
					proofbillcode: '',
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				if (this.row) {
					this.form.proofbillcode = this.row.proofbillcode
				}
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.activeName = this.device == 'pc' ? 'track' : 0
				this.$emit('hide')
			},
			show() {
				this.activeName = 'track'
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			submit() {
				//console.log(this.row)
				this.loading = true
				this.$api.purchasestockbill.updateproofbill({
					stockID: this.row.stockID,
					proofbillcode: this.form.proofbillcode
				}).then(
					() => {
						this.loading = false
						this.$message.success('操作成功')
						this.$emit('success')
						this.cancel()
						
					},()=>{
						this.loading = false
					})

				//this.cancel()
			}
		},
		components: {
			
		}
	}
</script>